module.exports = "/images/vendor/vue-paycard/src/unionpay.png?7d585d0bc58f57accf1d465116dd7426";